// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__183ah","title":"ClientCherryInfo_title__bj5Ky","itemText":"ClientCherryInfo_itemText__8rW-l"};